
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconFolderSelector = "fhi-icon-folder";

/**
 * ## FhiIconFolder
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-folder
 * @element fhi-icon-folder
 */
@customElement(FhiIconFolderSelector)
export class FhiIconFolder extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M7.93 2.25a2.75 2.75 0 0 1 2.292 1.23l.81 1.2.004.008a1.25 1.25 0 0 0 1.057.562H20A2.75 2.75 0 0 1 22.75 8v10A2.75 2.75 0 0 1 20 20.75H4A2.75 2.75 0 0 1 1.25 18V5A2.75 2.75 0 0 1 4 2.25zM4 3.75A1.25 1.25 0 0 0 2.75 5v13A1.25 1.25 0 0 0 4 19.25h16A1.25 1.25 0 0 0 21.25 18V8A1.25 1.25 0 0 0 20 6.75h-7.9v-.001a2.75 2.75 0 0 1-2.317-1.236v-.001L8.98 4.319l-.005-.006A1.25 1.25 0 0 0 7.93 3.75z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
